class Auth {
    constructor(name, pass) {
        this.user = name;
        this.pass = pass;
    }
}

module.exports = Auth;